import { render, staticRenderFns } from "./addHrHeathly.vue?vue&type=template&id=3bac8384&scoped=true"
import script from "./addHrHeathly.vue?vue&type=script&lang=js"
export * from "./addHrHeathly.vue?vue&type=script&lang=js"
import style0 from "./addHrHeathly.vue?vue&type=style&index=0&id=3bac8384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac8384",
  null
  
)

export default component.exports